<template>
  <div class='step2' style='margin-left: 450px'>
    <a-form-model layout="inline" ref='form' :model='model' :rules='validatorRules'>
      <a-form-model-item label='质疑周期' prop='content' required>
        <a-radio-group v-model='model.ddd' :options='radioOptions' />
      </a-form-model-item>
      <a-form-model-item  v-if='model.ddd === "指定周期"' prop='周期' required>
        <a-select placeholder='请选择周期' style='width: 200px'></a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'Step2',
  props: ['model'],
  data() {
    return {
      validatorRules: {},
      radioOptions: [{ label: '统一规则', value: '统一规则' }, { label: '指定周期', value: '指定周期' }]
    }
  },
  created() {
  },
  methods: {
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    }

  }

}
</script>

<style scoped>
.step2 {
  padding: 0 80px;
}

.header {
  font-size: 16px;
}

.list > .list-item {
  margin: 12px auto;
  width: 900px;
}

</style>
